import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIFlex from 'UIComponents/layout/UIFlex';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap, ProductLevelToSuiteBOHeaderTranslationKeyMap } from '../../constants/BusinessObjectivesTranslationKeys';
import ProductIcon from '../common/ProductIcon';
import SuiteBusinessObjectivesSubtext from '../merch-card/business-objectives/SuiteBusinessObjectivesSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuiteBusinessObjectives = ({
  productLevel
}) => {
  const DisplayedProductLines = AllCombinedProductLines;
  return /*#__PURE__*/_jsxs(UIAccordionItem, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.businessObjectives.seeDetails"
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: "p-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ProductLevelToSuiteBOHeaderTranslationKeyMap[productLevel]
      })
    }), DisplayedProductLines.map(localProductLine => {
      return /*#__PURE__*/_jsxs(UIFlex, {
        className: "m-y-1",
        align: "center",
        children: [/*#__PURE__*/_jsx(ProductIcon, {
          className: "display-inline m-right-3",
          productLine: localProductLine,
          style: {
            height: '35px'
          }
        }), /*#__PURE__*/_jsxs(UIFlex, {
          direction: "column",
          justify: "center",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(SuiteBusinessObjectivesSubtext, {
              productLevel: productLevel,
              productLine: localProductLine
            })
          })]
        })]
      }, localProductLine);
    })]
  });
};
export default MobileSuiteBusinessObjectives;